import moment from 'moment'
import isString from 'lodash/isString'
import i18n from 'i18next';
moment.locale('ja')
export const constUndef = () => undefined

export const required = value =>
  (value && (!isString(value) || value.trim())) || value === false ? undefined : i18n.t('features.Employees.components.BusinessInfoSection.please_input')

export const requiredIf = condition => condition ? required : constUndef

export const number = value => value && !value.match(/^\d+$/) ? i18n.t('features.Employees.components.BusinessInfoSection.please_enter_numbers') : undefined

const exactLengthNumberValidators = []
export const exactLengthNumber = len => {
  if (!exactLengthNumberValidators[len]) {
    exactLengthNumberValidators[len] = value => len && value && value.length > len ?  `は${len}桁の半角数字で入力してください` : undefined
  }
  return exactLengthNumberValidators[len]
}

const maxLengthValidators = []
export const maxLength = max => {
  if (!maxLengthValidators[max]) {
    maxLengthValidators[max] = value => value && value.length > max ? `を${max}文字以内で入れてください` : undefined
  }
  return maxLengthValidators[max]
}

export const adYearRegExp = /^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/;
export const jpYearRegExp = /^([MTSHR])(\d{1,2})\.(\d{1,2})\.(\d{1,2})$/i;
export const date = value =>
  value && ((!value.match(adYearRegExp) && !value.match(jpYearRegExp) && !moment(value, moment.ISO_8601).isValid()) || !moment(value, 'DD/MM/YYYY').isValid())
    ? i18n.t('features.JbcFront.errors.incorrect_format')
    : undefined;

export const monthYear = value =>
  !value || (value.length === 7 && moment(value, 'MM/YYYY', true).isValid()) ? undefined : i18n.t('features.JbcFront.errors.incorrect_format');
export const year = value =>
  !value || (value.length === 4 && moment(value, 'YYYY', true).isValid()) ? undefined : i18n.t('features.JbcFront.errors.incorrect_format');

const MB = 0x100000
const MAX_FILE_SIZE = 10 * MB

export const sizeBelow = value =>
  (value instanceof File && value.size > MAX_FILE_SIZE) ||
  (value instanceof Array && value.some(file => file instanceof File && file.size > MAX_FILE_SIZE))
    ? 'にアップロードできるファイル容量は10MB迄です。ご確認の上、再度アップロードください。'
    : undefined

export const sizeBelowNoLabel = value =>
  (value instanceof File && value.size > MAX_FILE_SIZE) ||
  (value instanceof Array && value.some(file => file instanceof File && file.size > MAX_FILE_SIZE))
    ? 'アップロードできるファイル容量は10MB迄です。ご確認の上、再度アップロードください。'
    : undefined
